import request from "@/utils/request"
// 营销活动主页: 从系统参数表中读取, Code1 为 MiniProgramOMS_TopActivie, 格式为 名称Name, 图片Url, 数量Qty
export function GetActiveHome(data) {
	return request({
		url: "/api/Mall/ActiveHome",
		method: "post",
		data
	})
}
// 活动Banner，有数据即代表有活动专栏
export function TopActiveBanner(data) {
	return request({
		url: "/api/Home/TopActiveBanner",
		method: "post",
		data
	})
}
